import { getPostHogFeatureFlagClient } from "@/shared/lib/monitoring/telemetry-config"

export const CHECKOUT_CONFIDENCE_STRIP_FLAG = "cro-checkout-confidence-strip"

export type CheckoutConfidenceStripVariant = "control" | "confidence_strip" | "unassigned"

interface PostHogWithFlags {
  getFeatureFlag: (key: string) => string | boolean | undefined
  onFeatureFlags?: (cb: () => void) => (() => void) | void
}

export function normalizeConfidenceStripVariant(
  raw: string | boolean | undefined
): CheckoutConfidenceStripVariant {
  if (raw === "confidence_strip") return "confidence_strip"
  if (raw === "control" || raw === false) return "control"
  return "unassigned"
}

export function getPostHogForConfidenceStrip(): PostHogWithFlags | null {
  return getPostHogFeatureFlagClient<PostHogWithFlags>()
}
